import {
  ActiveIcon,
  BackArrowIcon,
  InActiveIcon,
  LeftArrowIcon,
  RightArrowIcon,
  SearchIcon,
  SortDownIcon,
} from "@/assets/icons/admin";
import CustomDropdown from "@/components/admin/customdropdown";
import { ArrayItems } from "@/components/admin/customdropdown/dropdownarray";
import { useGetReferralById } from "@/services/referral.service";
import {
  Button,
  Input,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
  getKeyValue,
} from "@nextui-org/react";
import { useEffect, useState } from "react";

interface DownlineListProps {
  itemId: string;
  onCancel: () => void;
}

interface DownlineData {
  key: number;
  no: number;
  username: string;
  fullname: string;
  email: string;
  tier: string;
  status: string;
  usedate: string;
  totalprofit: string;
  totalcommission: string;
}

const DownlineList: React.FC<DownlineListProps> = ({ itemId, onCancel }) => {
  // const { data: getAllReferral } = useGetAllReferral();
  console.log("DownlineList itemId: " ,  itemId);

  // const {
  //   mutate: getReferralById,
  //   isLoading,
  //   isError,
  //   isSuccess,
  // } = useGetReferralById();
  const [tableRows, setTableRows] = useState<DownlineData[]>([]);

  const { data: getReferralData } = useGetReferralById(itemId, {
    page: 1,
    pageSize: 10,
  });

  // console.log("getReferralById : ", getReferralById?.data);

  useEffect(() =>{
       if (getReferralData?.data?.data) {
         console.log("getReferralData : ", getReferralData?.data?.data);
         const transformedData = getReferralData?.data?.data?.map(
           (item: any, index: any) => ({
             key: index + 1,
             no: index + 1,
             username: item.referral.userName,
             fullname:
               item.referral.fullName ||
               `${item.referral.firstName} ${item.referral.lastName}`,
             email: item.referral.email,
             status: item.referral.status,
             tier: item.level,
             usedate: item.createdAt,
             totalprofit: `$${item.myProfit.toLocaleString()}`,
             totalcommission: `$${item.totalCommission.toLocaleString()}`,
           }),
         );
         setTableRows(transformedData);
       }
    
    

  },[getReferralData]);
  
  


  // useEffect(() => {
  //   if (getReferralById?.data !== 0) {
  //     console.log("getReferralById : ", getReferralById?.data?.data);
  //     const transformedData = getReferralById?.data?.data?.map(
  //       (item: any, index: any) => ({
  //         key: index + 1,
  //         no: index + 1,
  //         username: item.referral.userName,
  //         fullname: item.referral.fullName || `${item.referral.firstName} ${item.referral.lastName}`,
  //         email: item.referral.email,
  //         status: item.referral.status,
  //         tier: item.level,
  //         usedate: item.updatedAt,
  //         totalprofit: `$${item.totalRewardAmount.toLocaleString()}`,
  //         totalcommission: `$${item.totalRewardAmount.toLocaleString()}`,

  //           //     key: 1,
  // //     no: 1,
  // //     username: "jennie21",
  // //     fullname: "Jennnie Scott",
  // //     email: "Jennie@shark.com",
  // //     tier: "Silver",
  // //     status: "Active",
  // //     usedate: "02/06/2022  15:38:40",
  // //     totalprofit: "$23.343,23",
  // //     totalcommission: "$23.343,23",
  //       }),
  //     );
  //     setTableRows(transformedData);
  //   }
  // }, [getReferralById, isFetched]);
  

  const statuses = [
    { label: "All", value: "all" },
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
    { label: "Suspend", value: "suspend" },
  ];

  const columns = [
    {
      key: "no",
      label: "No",
    },
    {
      key: "username",
      label: "Username",
    },
    {
      key: "fullname",
      label: "Fullname",
    },
    {
      key: "email",
      label: "Email",
    },
    {
      key: "tier",
      label: "Tier",
    },
    {
      key: "status",
      label: "Status",
    },
    {
      key: "usedate",
      label: "Use Date",
    },
    {
      key: "totalprofit",
      label: "Total Profit",
    },
    {
      key: "totalcommission",
      label: "My Comission",
    },
  ];

  // const tableRows = [
  //   {
  //     key: 1,
  //     no: 1,
  //     username: "jennie21",
  //     fullname: "Jennnie Scott",
  //     email: "Jennie@shark.com",
  //     tier: "Silver",
  //     status: "Active",
  //     usedate: "02/06/2022  15:38:40",
  //     totalprofit: "$23.343,23",
  //     totalcommission: "$23.343,23",
  //   },
  //   {
  //     key: 2,
  //     no: 2,
  //     username: "jennie21",
  //     fullname: "Jennnie Scott",
  //     email: "Jennie@shark.com",
  //     tier: "Gold",
  //     status: "Inactive",
  //     usedate: "02/06/2022  15:38:40",
  //     totalprofit: "$23.343,23",
  //     totalcommission: "$23.343,23",
  //   },
  //   {
  //     key: 3,
  //     no: 3,
  //     username: "jennie21",
  //     fullname: "Jennnie Scott",
  //     email: "Jennie@shark.com",
  //     tier: "Bronze",
  //     status: "Active",
  //     usedate: "02/06/2022  15:38:40",
  //     totalprofit: "$23.343,23",
  //     totalcommission: "$23.343,23",
  //   },
  //   {
  //     key: 4,
  //     no: 4,
  //     username: "jennie21",
  //     fullname: "Jennnie Scott",
  //     email: "Jennie@shark.com",
  //     tier: "Silver",
  //     status: "Inactive",
  //     usedate: "02/06/2022  15:38:40",
  //     totalprofit: "$23.343,23",
  //     totalcommission: "$23.343,23",
  //   },
  //   {
  //     key: 5,
  //     no: 5,
  //     username: "jennie21",
  //     fullname: "Jennnie Scott",
  //     email: "Jennie@shark.com",
  //     tier: "Bronze",
  //     status: "Active",
  //     usedate: "02/06/2022  15:38:40",
  //     totalprofit: "$23.343,23",
  //     totalcommission: "$23.343,23",
  //   },
  //   {
  //     key: 6,
  //     no: 6,
  //     username: "jennie21",
  //     fullname: "Jennnie Scott",
  //     email: "Jennie@shark.com",
  //     tier: "Silver",
  //     status: "Inactive",
  //     usedate: "02/06/2022  15:38:40",
  //     totalprofit: "$23.343,23",
  //     totalcommission: "$23.343,23",
  //   },
  //   {
  //     key: 7,
  //     no: 7,
  //     username: "jennie21",
  //     fullname: "Jennnie Scott",
  //     email: "Jennie@shark.com",
  //     tier: "Bronze",
  //     status: "Active",
  //     usedate: "02/06/2022  15:38:40",
  //     totalprofit: "$23.343,23",
  //     totalcommission: "$23.343,23",
  //   },
  // ];

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPageOptions = ["All", "3", "5", "10"];
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);
  console.log(itemId);

  const handleChangeRowsPerPage = (e: any) => {
    setRowsPerPage(e.target.value);
    setCurrentPage(1);
  };

  const handleClickNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handleClickPrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  let paginatedRows = tableRows;
  if (rowsPerPage !== "All") {
    paginatedRows = tableRows.slice(
      (currentPage - 1) * parseInt(rowsPerPage),
      currentPage * parseInt(rowsPerPage),
    );
  }

  const totalRows = tableRows?.length;
  const startRow = (currentPage - 1) * paginatedRows?.length + 1;
  const endRow = Math.min(currentPage * paginatedRows?.length, totalRows);

  const rowsRange = `${startRow}-${endRow} out of ${totalRows}`;

  const handleDropdownSelect = (selectedOption: ArrayItems | null) => {
    console.log("Selected option:", selectedOption);
  };

  const formatDateTime = (isoString: string | number | Date) => {
    const date = new Date(isoString);
  
    const padZero = (num: number) => (num < 10 ? "0" : "") + num;
  
    const day = padZero(date.getDate());
    const month = padZero(date.getMonth() + 1); // getMonth() returns month from 0 to 11
    const year = date.getFullYear(); // Get full year
    const hours = padZero(date.getHours());
    const minutes = padZero(date.getMinutes());
    const seconds = padZero(date.getSeconds()); // Add this line to get seconds
  
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`; // Include seconds in the returned string
  }; 

  return (
    <div>
      <div className="font-ubuntu mb-4 w-full text-center text-2xl font-semibold text-white sm:float-left">
        <span>
          <Button
            isIconOnly
            onClick={onCancel}
            className="transparent-bg float-left ml-[-11px] h-auto w-auto"
          >
            <BackArrowIcon />
          </Button>
          <p className="text-sm sm:float-left sm:text-lg md:text-lg lg:text-lg">
            Downline List
          </p>
        </span>
      </div>
      <div className="flex w-full flex-col gap-4">
        <div className="mb-6 flex w-auto flex-wrap items-start gap-4 sm:mt-5 md:mb-0 md:flex-nowrap">
          <div className="w-full sm:w-2/4">
            <CustomDropdown
              options={statuses}
              onSelect={handleDropdownSelect}
              placeholder="All"
            />
          </div>
          <Input
            className="input-bg w-2/4"
            isClearable
            classNames={{
              input: [
                "mr-0",
                "text-black/90 dark:text-white/90",
                "placeholder:text-default-700/50 dark:placeholder:text-white/60",
              ],
              inputWrapper: [
                "shadow-xl",
                "!cursor-text",
                "bg-white-5",
                "text-[11px]",
              ],
            }}
            placeholder="Search Username"
            startContent={<SearchIcon />}
          ></Input>
          <Button className="admin-common-button-gradient font-ubuntu w-[155px] rounded-md text-base font-bold">
            Apply
          </Button>
          <div className="float-right ml-96 ms-auto w-1/2"></div>
        </div>
      </div>
      <div className="w-full sm:mt-5">
        <div className="w-full overflow-x-auto">
          <Table
            removeWrapper
            className="table-striped table-striped-even table"
          >
            <TableHeader className="rounded-none" columns={columns}>
              {(column) => (
                <TableColumn key={column.key}>
                  <div className="white-op flex">
                    {column.label}
                    <Button isIconOnly className="transparent-bg h-auto w-auto">
                      <SortDownIcon />
                    </Button>
                  </div>
                </TableColumn>
              )}
            </TableHeader>
            <TableBody items={paginatedRows}>
              {(item) => (
                <TableRow key={item.key}>
                  {(columnKey) => (
                    <TableCell>
                      {columnKey === "status" ? (
                        <div className="flex items-center">
                          {item.status === "ACTIVE" ? (
                            <span>
                              <ActiveIcon />
                            </span>
                          ) : (
                            <span>
                              <InActiveIcon />
                            </span>
                          )}
                        </div>
                      ) : columnKey === "no" ? (
                        getKeyValue(item, columnKey) + "."
                      ) : columnKey === "username" ? (
                        <div className="tb-data-blue">
                          {" "}
                          {getKeyValue(item, columnKey)}
                        </div>
                      ) : columnKey === "tier" ? (
                        <div className="font-bold">
                          {"Level "}
                          {getKeyValue(item, columnKey)}
                        </div>
                      ) : columnKey === "usedate" ? (
                        <div className="w-max">
                          {" "}
                          {formatDateTime(getKeyValue(item, columnKey))}
                        </div>
                      ) : (
                        <div className="font-normal">
                          {" "}
                          {getKeyValue(item, columnKey)}
                        </div>
                      )}
                    </TableCell>
                  )}
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        <div className="table-striped-even mt-1	flex items-center text-sm sm:justify-end sm:text-base">
          <div className="ml-[15px] justify-start sm:ml-0 sm:ml-4 sm:mr-8">
            <label
              htmlFor="rowsPerPage"
              className="font-sans opacity-30 sm:mr-2"
            >
              Rows per page:
            </label>
            <select
              id="rowsPerPage"
              className="select-menu font-open-sans rounded border-none bg-transparent px-2 py-1 font-normal text-gray-500"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
            >
              {rowsPerPageOptions.map((option) => (
                <option
                  key={option}
                  value={option}
                  className="font-open-sans text-gray-600 sm:font-normal"
                >
                  {option}
                </option>
              ))}
            </select>
          </div>
          <div className="flex">
            <div className="ml-[8px] mt-2 opacity-30 sm:ml-[45px] sm:mr-8">
              <p>{rowsRange}</p>
            </div>
            <button
              onClick={handleClickPrevPage}
              className="ml-[18px] mr-2 text-xs sm:ml-0 sm:mr-3"
            >
              <LeftArrowIcon />
            </button>
            <button onClick={handleClickNextPage} className="text-xs">
              <RightArrowIcon />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownlineList;
